import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import ThemesTableColumns from './ThemesTableColumns';

const ThemesTableHeader = ({
  children,
  loaderButton,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns="3"
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    <ThemesTableColumns />
  </Table.Header>
);

export default ThemesTableHeader;
